const activity = {
  activity: "Atividade", // translated
  activities: "Atividades", // translated
  dates: "datas", // translated
  location: "Localização", // translated
  languages: "línguas", // translated
  categories: "Categorias", // translated
  ticketOption: "Opção de ingresso", // translated
  numberOfRatings: "Número de avaliações", // translated
  meetingPointInfo: "Informações sobre pontos de encontro", // translated
  meetingPoint: "Ponto de encontro", // translated
  meetingPoints: "Pontos de encontro", // translated
  providedBy: "Fornecido por", // translated
  expirationDate: "Data de validade", // translated
  groupSize: "Tamanho do grupo", // translated
  features: "Características", // translated
  basedOn: "Baseado em", // translated
  reviewsFromVerCustomers: "comentários de clientes verificados", // translated
  excellent: "excelente", // translated
  great: "ótimo", // translated
  average: "média", // translated
  poor: "pobre", // translated
  bad: "ruim", // translated
  onlyBookedCustomersTooltip: "Somente clientes que reservaram esta atividade podem deixar um comentário", // translated
  noReviewsYet: "No momento não há avaliações para esta atividade.", // translated
  backToActivitiesList: "Voltar à lista de atividades", // translated
  getPrices: "obter preços", // translated
  availabilityAndPrices: "Disponibilidade e preços", // translated
  ticketOptions: "Opções de ingressos", // translated
  ticketInfo: "Informações sobre ingressos", // translated
  selectYourTickets: "Selecione seus ingressos", // translated
  product: "produtos", // translated
  total: "Total", // translated
  slot: "Slot", // translated
  language: "Linguagem", // translated
  tickets: "Ingressos", // translated
  ticketsFor: "Ingressos para", // translated
  previousStep: "Passo anterior", // translated
  onlyAvailableInEnglish: "Disponível apenas em inglês", // translated
  guest: "Convidado", // translated
  leadGuest: "Convidado principal", // translated
  adult: "Adulto", // translated
  child: "Criança", // translated
  pleaseSelectAdult: "Selecione pelo menos um adulto", // translated
  notAvailableActivity: "Este produto não está disponível", // translated
  required: "Obrigatório", // translated
  pickupPoint: "Ponto de coleta", // translated
  pickupPoints: "Pontos de coleta", // translated
  ticketType: "Tipo de bilhete", // translated
  anonymous: "Anônimo", // translated
  printedVoucher: "Voucher impresso aceito", // translated
  mobileVoucher: "Voucher móvel aceito", // translated
  mixedVoucher: "Voucher móvel ou impresso aceito", // translated
  safetyMeasures: "Medidas de segurança aplicadas", // translated
  doThisBecause: "Faça isso porque", // translated
  safetyInfo: "Informações de segurança", // translated
  reviewsHighestFirst: "Número de avaliações (o mais alto primeiro)", // translated
  bookingFee: "Taxa de reserva", // translated
  startDate: "Data de início", // translated
  endDate: "Data final", // translated
  cancellationDeadlineAndFees: "Prazo de cancelamento e taxas", // translated
  resetTickets: "Redefinir tíquetes", // translated
  instantConfirmation: "Confirmação instantânea", // translated
  clickResetBtn: "Clique no botão reset para reiniciar sua seleção", // translated
};


export default activity;
